import { Component } from '@angular/core';
import { ResearchCvTagEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Cv Tags') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchcvtag-form',
    templateUrl: './researchcvtag.form.component.html'
})
export class ResearchCvTagFormComponent extends BaseFormComponent {
    public record!: ResearchCvTagEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

